import "../assets/css/--component-loader.css";

function Loader() {
  return (
    <div id="primaryLoader">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;